import React, { Component } from "react";
import { Fragment } from "react";
// import Trucks_Schedule from "./Trucks_Schedule.js";
import Trucks_Available from "./Trucks_Available.js";
import "./BlockData.css";
import axios from "axios";
import { API_URL1 } from "../services/url";
import { LinearProgress } from "@material-ui/core";
// Lightweight stat card used across the dashboard
const StatCard = ({ label, value, sublabel }) => (
  <div
    style={{
      flex: '1 1 260px',
      minWidth: 260,
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      borderRadius: 12,
      boxShadow: '0 8px 16px rgba(2,6,23,0.06)',
      padding: '16px 18px',
      margin: 8
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
      <div style={{ 
        width: 5, 
        height: 18, 
        background: 'linear-gradient(135deg, #991C1C 0%, #7d1616 50%, #6b1212 100%)', 
        borderRadius: 3, 
        marginRight: 10 
      }}></div>
      <div style={{ fontSize: 13, color: '#64748b', fontWeight: 600 }}>{label}</div>
    </div>
    <div style={{ fontSize: 28, fontWeight: 800, color: '#0f172a', lineHeight: 1 }}>{Number(value || 0).toFixed(2)}</div>
    {sublabel ? (
      <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600, marginTop: 6 }}>{sublabel}</div>
    ) : null}
  </div>
);

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Udata: [],
      Dispatch_today: "",
      Dispatch_week: "",
      Dispatch_year: "",
      tons_today: "",
      tons_week: "",
      tons_year: "",
      hauled_today: "",
      hauled_week: "",
      hauled_year: "",
      record: false,
    };
  }
  async componentDidMount() {
    try {
      var truck_company_id = localStorage.getItem("adminid");

      const response = await axios.get(
        `${API_URL1}trucker/dashboardNew/${truck_company_id}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("TruckertokenKey"),
            "content-type": "application/json",
          },
        }
      );
      const response1 = await axios.get(
        `${API_URL1}trucker/dashboardNew/dashboardTruckSchedule/${truck_company_id}`
      );

      if (response.data.truckes) {
        this.setState({
          Udata: response1.data.success.data,
          dispatch_today: response.data.truckes[1][0].dispatch_today,
          dispatch_week: response.data.truckes[1][0].dispatch_week,
          dispatch_year: response.data.truckes[2][0].dispatch_year,
          tons_today: response.data.truckes[3][0].tons_today,
          tons_week: response.data.truckes[4][0].tons_week,
          tons_year: response.data.truckes[5][0].tons_year,
          hauled_today: response.data.truckes[6][0].hauled_today,
          hauled_week: response.data.truckes[7][0].hauled_week,
          hauled_year: response.data.truckes[8][0].hauled_year,
          record: true,
        });
      } else {
        this.setState({ record: true });
      }
    } catch (error) {}
  }
  render() {
    return (
      <Fragment>
        {!this.state.record ? <LinearProgress /> : ""}
        <div style={{
          backgroundColor: '#f8f9fa'
        }}>
          {/* Page header */}
          <div style={{ padding: '24px 24px 8px 24px' }}>
            <h1 style={{
              margin: 0,
              fontSize: 28,
              fontWeight: 800,
              color: '#0f172a',
              letterSpacing: 0.2
            }}>Dashboard Overview</h1>
            <p style={{ margin: '6px 0 0 0', color: '#64748b', fontSize: 14 }}>Track dispatches, tons moved and loads hauled</p>
          </div>

          {/* Stats grid */}
          <div style={{ padding: '8px 16px 16px 16px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <StatCard label="Dispatched Today" value={this.state.dispatch_today} sublabel="Today" />
              <StatCard label="Dispatched This Week" value={this.state.dispatch_week} sublabel="Last 7 days" />
              <StatCard label="Dispatched This Year" value={this.state.dispatch_year} sublabel="Last 365 days" />

              <StatCard label="Tons Moved Today" value={this.state.tons_today} sublabel="Today" />
              <StatCard label="Tons Moved This Week" value={this.state.tons_week} sublabel="Last 7 days" />
              <StatCard label="Tons Moved This Year" value={this.state.tons_year} sublabel="Last 365 days" />

              <StatCard label="Loads Hauled Today" value={this.state.hauled_today} sublabel="Today" />
              <StatCard label="Loads Hauled This Week" value={this.state.hauled_week} sublabel="Last 7 days" />
              <StatCard label="Loads Hauled This Year" value={this.state.hauled_year} sublabel="Last 365 days" />
            </div>
          </div>

          {/* Trucks Available */}
          <div style={{ padding: '0 16px 24px 16px' }}>
            <div style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              boxShadow: '0 8px 16px rgba(2,6,23,0.06)',
              padding: 16
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <div style={{ width: 4, height: 20, background: '#991C1C', borderRadius: 2, marginRight: 8 }}></div>
                <div style={{ fontWeight: 800, color: '#0f172a' }}>Trucks Available</div>
              </div>
              <Trucks_Available Udata={this.state.Udata} loading={this.state.loading} />
            </div>
          </div>
          {/* <div className="row col-lg-12 d-flex justify-content-around mt-5">
            <Trucks_Schedule
              Udata={this.state.Udata}
              loading={this.state.loading}
            />
          </div> */}
        </div>
      </Fragment>
    );
  }
}

export default Dashboard;
